import { render, staticRenderFns } from "./ApplyJoins.vue?vue&type=template&id=4dec55ba&scoped=true&"
import script from "./ApplyJoins.vue?vue&type=script&lang=js&"
export * from "./ApplyJoins.vue?vue&type=script&lang=js&"
import style0 from "./ApplyJoins.vue?vue&type=style&index=0&id=4dec55ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec55ba",
  null
  
)

export default component.exports